import { msg } from "@lingui/core/macro";

export const startTimeRuleMessages = {
	name: msg({ message: "Start Time" }),
	description: msg({ message: "Set the permit start time" }),
} as const;
